import { isIOS } from '@/libraries/utils/userAgent';

document.addEventListener('touchmove', (event) => {
    if (event.touches.length > 1) {
        event.preventDefault();
        event.stopPropagation();
    }
}, false);

let lastTouchEnd = 0;
document.addEventListener('touchend', (event) => {
    const now = (new Date()).getTime();
    if (now - lastTouchEnd <= 100) {
        event.preventDefault();
        event.stopPropagation();
    }
    lastTouchEnd = now;
}, false);

document.addEventListener('touchcancel', (event) => {
    event.preventDefault();
    event.stopPropagation();
}, false);

let lastClickEnd = 0;
document.addEventListener('click', (event) => {
    const now = (new Date()).getTime();
    if (lastClickEnd + 10 > now) {
        event.preventDefault();
        event.stopPropagation();
    }
    lastClickEnd = now;
}, false);

let lastIosClickEnd = 0;
document.body.addEventListener('click', (event) => {
    const now = (new Date()).getTime();
    if (isIOS() && lastIosClickEnd + 10 > now) {
        event.preventDefault();
        event.stopPropagation();
    }
    lastIosClickEnd = now;
}, { passive: false });
